import { Link } from "react-router-dom";
import logo from "@/assets/logo.png";
import { Facebook, Instagram, Twitter, Youtube, Mail, MapPin } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-foreground text-card py-16">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img src={logo} alt="Plateia.fun" className="h-20 lg:h-24 brightness-0 invert" />
            <p className="text-card/70 text-sm leading-relaxed">
              A plataforma mais divertida para vender ingressos. 
              Impossível não se divertir aqui!
            </p>
            <div className="flex gap-4">
              <a href="https://facebook.com/plateia.fun" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-card/60 hover:text-gold transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com/plateia.fun" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-card/60 hover:text-gold transition-colors">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com/plateia.fun" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-card/60 hover:text-gold transition-colors">
                <Twitter size={20} />
              </a>
              <a href="https://youtube.com/@plateia.fun" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-card/60 hover:text-gold transition-colors">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Plataforma */}
          <div className="space-y-4">
            <h3 className="font-heading font-semibold text-lg">Plataforma</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/como-funciona" className="text-card/70 hover:text-card transition-colors text-sm">
                  Como funciona
                </Link>
              </li>
              <li>
                <Link to="/precos" className="text-card/70 hover:text-card transition-colors text-sm">
                  Preços e taxas
                </Link>
              </li>
              <li>
                <Link to="/recursos" className="text-card/70 hover:text-card transition-colors text-sm">
                  Recursos
                </Link>
              </li>
              <li>
                <Link to="/casos" className="text-card/70 hover:text-card transition-colors text-sm">
                  Casos de sucesso
                </Link>
              </li>
            </ul>
          </div>

          {/* Suporte */}
          <div className="space-y-4">
            <h3 className="font-heading font-semibold text-lg">Suporte</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/ajuda" className="text-card/70 hover:text-card transition-colors text-sm">
                  Central de ajuda
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-card/70 hover:text-card transition-colors text-sm">
                  Fale conosco
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div className="space-y-4">
            <h3 className="font-heading font-semibold text-lg">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-card/70 text-sm">
                <Mail size={16} />
                <span>contato@plateia.fun</span>
              </li>
              <li className="flex items-start gap-2 text-card/70 text-sm">
                <MapPin size={16} className="mt-0.5" />
                <span>São Carlos, Brasil</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-card/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-card/50 text-sm">
            © 2025 Plateia.fun. Todos os direitos reservados.
          </p>
          <div className="flex flex-wrap gap-6 text-sm">
            <Link to="/termos" className="text-card/50 hover:text-card transition-colors">
              Termos de uso
            </Link>
            <Link to="/privacidade" className="text-card/50 hover:text-card transition-colors">
              Política de privacidade
            </Link>
            <Link to="/politica-cancelamento" className="text-card/50 hover:text-card transition-colors">
              Cancelamento
            </Link>
            <Link to="/reembolsos" className="text-card/50 hover:text-card transition-colors">
              Reembolsos
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
